import Button from "components/Button";
import { Grid } from "components/Grid/Grid";
import Loader from "components/Loader";
import Modal from "components/Modal";
import RadioGroup from "components/RadioGroup";
import SingleSelect from "components/SingleSelect";
import Text from "components/Text";
import TextInput from "components/TextInput";
import PageContent from "pages/PageContent";
import {
    ProfileContentWrapper,
    StraightLine,
    SubHeading,
} from "pages/PageContent/PageContent.styled";
import { FC } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { FcInfo } from "react-icons/fc";
import theme from "theme";
import { Label, Note } from "./ContactDetails.styled";
import { useContactDetails } from "./useContactDetails";

export const ContactDetails: FC = () => {
    const {
        radioGroupOptions,
        countryCodeOptions,
        inputs,
        handleInputChange,
        handleCountryCodeChange,
        inputErrors,
        onSubmit,
        isLoading,
        isFetching,
        handleBack,
        isModalOpen,
        toggleModal,
    } = useContactDetails();

    return (
        <PageContent>
            <ProfileContentWrapper>
                <Text
                    variant="heading5"
                    fontWeight="700"
                    color={theme.colors.grey.dark}
                >
                    Complete Your Profile (7/7)
                </Text>
                <SubHeading variant="label">
                    CONTACT DETAILS <StraightLine />
                </SubHeading>
                {isFetching && <Loader size={28} />}
                {!isFetching && (
                    <>
                        <Grid
                            row={true}
                            columnGap={2}
                            marginTop={1}
                            marginBottom={2}
                        >
                            <SingleSelect
                                name="countryCode1"
                                label="Code"
                                placeholder="+91"
                                required
                                minWidth="100px"
                                options={countryCodeOptions}
                                value={inputs.countryCode1}
                                onChange={(value) =>
                                    handleCountryCodeChange(
                                        "countryCode1",
                                        value
                                    )
                                }
                                searchable
                                disabled={isLoading}
                            />
                            <TextInput
                                name="mobileNumber1"
                                type="number"
                                label="Mobile Number"
                                required
                                placeholder="1234567890"
                                labelColor={theme.colors.text}
                                minWidth="160px"
                                value={inputs.mobileNumber1}
                                errorMsg={inputErrors.mobileNumber1}
                                onChange={handleInputChange}
                                disabled={isLoading}
                            />
                        </Grid>
                        {/* <Label variant="heading4" required>
                            Is your whatsapp number different?
                        </Label> */}
                        <RadioGroup
                            name="isDifferentWhatsAppNumber"
                            value={inputs.isDifferentWhatsAppNumber}
                            options={radioGroupOptions}
                            onChange={handleInputChange}
                            disabled={isLoading}
                            labelColor={theme.colors.grey.primary}
                            label="Is your whatsapp number different?"
                            required={
                                inputs.isDifferentWhatsAppNumber === "yes"
                            }
                        />
                        {inputs.isDifferentWhatsAppNumber === "yes" && (
                            <>
                                <SubHeading variant="label">
                                    WHATSAPP NUMBER <StraightLine />
                                </SubHeading>
                                <Grid
                                    row={true}
                                    columnGap={2}
                                    marginTop={1}
                                    marginBottom={2}
                                >
                                    <SingleSelect
                                        name="countryCode2"
                                        label="Code"
                                        placeholder="+91"
                                        required={
                                            inputs.isDifferentWhatsAppNumber ===
                                            "yes"
                                        }
                                        minWidth="100px"
                                        options={countryCodeOptions}
                                        value={inputs.countryCode2}
                                        onChange={(value) =>
                                            handleCountryCodeChange(
                                                "countryCode2",
                                                value
                                            )
                                        }
                                        searchable
                                        disabled={isLoading}
                                    />
                                    <TextInput
                                        name="mobileNumber2"
                                        type="text"
                                        label="Mobile Number"
                                        required={
                                            inputs.isDifferentWhatsAppNumber ===
                                            "yes"
                                        }
                                        placeholder="1234567890"
                                        labelColor={theme.colors.text}
                                        minWidth="160px"
                                        value={inputs.mobileNumber2}
                                        onChange={handleInputChange}
                                        errorMsg={inputErrors.mobileNumber2}
                                        disabled={isLoading}
                                    />
                                </Grid>
                            </>
                        )}
                        <Note>
                            <FcInfo />
                            <Label variant="heading4">
                                Don’t worry, the mobile number is only displayed
                                to clients if there is an audition/job for you.
                            </Label>
                        </Note>
                        <Grid row={true} expanded marginTop={2} columnGap={1}>
                            <Button
                                type="button"
                                variant="outlined"
                                icon={<BsArrowLeft />}
                                iconPosition="prefix"
                                onClick={toggleModal}
                            >
                                Back
                            </Button>
                            <Button
                                type="button"
                                variant="filled"
                                onClick={onSubmit}
                                disabled={isLoading}
                                isLoading={isLoading}
                            >
                                Save & Done
                            </Button>
                        </Grid>
                    </>
                )}
            </ProfileContentWrapper>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <Modal.Header>
                    <Text variant="heading3">Confirm</Text>
                </Modal.Header>
                <Modal.Content>
                    <Text variant="body1">
                        Are you sure you want to leave? Any unsaved changes will
                        be lost.
                    </Text>
                </Modal.Content>
                <Modal.Footer>
                    <Grid
                        row={true}
                        justify="flex-end"
                        expanded
                        columnGap={1}
                        marginTop={2}
                    >
                        <Button
                            type="button"
                            variant="outlined"
                            onClick={toggleModal}
                        >
                            No
                        </Button>
                        <Button
                            type="button"
                            variant="filled"
                            onClick={handleBack}
                        >
                            Yes
                        </Button>
                    </Grid>
                </Modal.Footer>
            </Modal>
        </PageContent>
    );
};
